"use client";

import React from "react";

interface AuthorLinkProps {
    author: string;
    authorUrl?: string;
    authorPhoto?: string;
    className?: string;
}

export default function AuthorLink({ author, authorUrl, authorPhoto, className = "" }: AuthorLinkProps) {
    if (!authorUrl) {
        return <span className={className}>{author}</span>;
    }

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
    };

    return (
        <a
            href={authorUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-flex items-center gap-2 group/author ${className}`}
            onClick={handleClick}
        >
            {authorPhoto && (
                <div className="w-5 h-5 rounded-full overflow-hidden bg-gray-100 flex-shrink-0 group-hover/author:ring-1 group-hover/author:ring-black transition-all">
                    <img src={authorPhoto} alt={author} className="w-full h-full object-cover" />
                </div>
            )}
            <span className="truncate">{author}</span>
        </a>
    );
}
